import { getBaseURL, getQueryString } from '@vue/store/helpers.js';
import axios from 'axios';
const ENDPOINT = 'saved-search';

export const getSavedSearches = ({params}) => {
  return new Promise((resolve, reject) => {
    try {
      if(!params) {
        reject('saved search API :: getSavedSearches :: Invalid Form Params :', params);
        return false;
      }

      let requestURL = getBaseURL() + '/saved-searches';
      let queryString = getQueryString(params);

      requestURL += `?${queryString}`;
            
      axios.get(requestURL, params)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

/**
 * 
 * @param {string} userId User ID you want to store saved search for
 * @param {object} params Saved Search parameters (min_asking_price, search_type, etc)
 * @returns {promise}
 */
export const store = ({userId, params}) => {
  return new Promise((resolve, reject) => {
    try {
      params.selected_user = userId;
      let requestURL = getBaseURL() + '/saved-searches';
      axios.post(requestURL, params)
        .then(response => resolve(response))
        .catch(err => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

/**
* 
* @param {string} userId User ID you want to store saved search for
* @param {string} id ID of the saved search record you want to update
* @param {object} params Saved Search parameters (min_asking_price, search_type, etc)
* @returns {promise}
*/
export const update = ({userId, id, params}) => {
  return new Promise((resolve, reject) => {
    try {
      let requestURL = getBaseURL() + `/saved-searches/${id}`;
      axios.put(requestURL, params)
        .then(response => resolve(response))
        .catch(err => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

/**
* 
* @param {string} userId User ID you want to store saved search for
* @param {string} id ID of the saved search record you want to delete
* @returns {promise}
*/
export const destroy = ({userId, id}) => {
  return new Promise((resolve, reject) => {
    try {
      let data = {};
      let requestURL = getBaseURL() + `/saved-searches/${id}`;
      if(parseInt(userId)){
        data.selected_user = userId;
      }
      axios.delete(requestURL, data)
        .then(response => resolve(response))
        .catch(err => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

/**
 * 
 * @param {string} userId User ID you want to store saved search for
 * @param {object} params Saved Search parameters (min_asking_price, search_type, etc)
 * @returns {promise}
 */
 export const storeWatchlist = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      let requestURL = getBaseURL() + '/watchlist';
      axios.post(requestURL, payload)
        .then(response => resolve(response))
        .catch(err => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};